export default "__VITE_ASSET__D_7vR03U__"